var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBusSchwarz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.25 23.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg4993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3000",
    d: "M17.18,0c-2.27,0-4.83.06-7.85.14C-.3.65,0,10.34,0,18.5c.11.93,1.7.82,3.32.8h.58a4.28,4.28,0,0,1,4.36-3.81,4.28,4.28,0,0,1,4.36,3.81H26.9a4.41,4.41,0,0,1,8.73,0c3.18-.1,2.62-.9,2.51-4.82V6.79c0-4.36.58-6.53-3.7-6.59C28.16.18,24,0,17.18,0ZM13.69,1.43h4.74a1.23,1.23,0,0,1,1.23,1.24V6.74A1.23,1.23,0,0,1,18.43,8H13.69a1.24,1.24,0,0,1-1.24-1.24V2.67A1.24,1.24,0,0,1,13.69,1.43Zm8.31,0h4.73A1.25,1.25,0,0,1,28,2.67V6.74A1.25,1.25,0,0,1,26.73,8H22a1.24,1.24,0,0,1-1.24-1.24V2.67A1.24,1.24,0,0,1,22,1.43Zm8.31,0h4.75a1.23,1.23,0,0,1,1.22,1.24V6.74A1.23,1.23,0,0,1,35.06,8H30.31a1.25,1.25,0,0,1-1.24-1.24V2.67A1.25,1.25,0,0,1,30.31,1.43ZM9.59,1.49c1.08,0,1,.7,1,1.2v9.17c-1.87,1.85-9.54,5.55-9.14,0A15.14,15.14,0,0,1,3.43,4.7C4.64,2.57,7,1.75,9.36,1.51l.23,0ZM8.27,16.27A3.75,3.75,0,1,0,12.08,20,3.77,3.77,0,0,0,8.27,16.27Zm23,0A3.75,3.75,0,1,0,35.07,20,3.78,3.78,0,0,0,31.27,16.27ZM8.3,18.6A1.32,1.32,0,1,1,7,19.92,1.32,1.32,0,0,1,8.3,18.6Zm22.93,0a1.32,1.32,0,0,1,0,2.64,1.32,1.32,0,1,1,0-2.64Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusSchwarz);
export default __webpack_public_path__ + "static/media/icon_bus_schwarz.b54d72e7ba5912f22a8029b835fe2969.svg";
export { ForwardRef as ReactComponent };